import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import BreederProfileEmptyResults from 'dpl/components/BreederProfile/Index/BreederProfileEmptyResults';

function BreederProfileEmptyResultsContainer(props) {
  return <BreederProfileEmptyResults {...props} />;
}

export default compose(
  connect(({ server }) => ({ breedName: server.breedName }))
)(BreederProfileEmptyResultsContainer);
